import { useNavigate } from "react-router-dom";

/* Bridges the prototype's go("route") nav calls onto react-router. */
export function useGo() {
  const navigate = useNavigate();
  return (id: string) => navigate("/" + id);
}
